import { Navigate, useLocation } from 'react-router-dom';
import { ReactElement } from 'react';
import { useHasPermission } from '../hooks/useAuth';
import { Permission } from '../types/user';

interface PermissionRouteProps {
  permission: Permission;
  children: ReactElement;
}

const PermissionRoute = ({ permission, children }: PermissionRouteProps) => {
  const allowed = useHasPermission(permission);
  const location = useLocation();

  if (!allowed) {
    return (
      <Navigate
        to="/forbidden"
        state={{ requiredPermission: permission, from: location }}
        replace
      />
    );
  }

  return children;
};

export default PermissionRoute;
